import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  addDoc,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,       // Add this import
  query,
  orderBy,
  where,
  onSnapshot
} from "firebase/firestore";


const firebaseConfig = {
    apiKey: "AIzaSyDtN2tZKlmu64KF_3eGpQ7fVAylJY0xYvk",
    authDomain: "lakeridgedms-76432.firebaseapp.com",
    projectId: "lakeridgedms-76432",
    storageBucket: "lakeridgedms-76432.firebasestorage.app",
    messagingSenderId: "15513128008",
    appId: "1:15513128008:web:29a56b75535b40a0321c7d",
    measurementId: "G-CZDQMSXGQH"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export {
    db,
    collection,
    addDoc,
    doc,
    getDoc,
    getDocs,
    setDoc,
    updateDoc,
    deleteDoc,       // And export it here
    query,
    orderBy,
    where,
    onSnapshot
  };